<template>
  <div class="nav">
    <div class="toptips" v-show="istips == true">
      By continuing to use our website and/or services you agree to the updated Privacy Policy and the use of cookies as
      well as our &nbsp;<router-link to="term">Terms and Conditions</router-link>
      <!-- <i class="el-icon-close" @click="closexy()"></i> -->
      <div class="agree" @click="closexy()">
        Agree
      </div>
    </div>
    <div class="nav_main">
      <router-link to="/home">
        <div class="logo">
          <img :src="pageConfig.logo" @load="imgLoad" />
        </div>
      </router-link>

      <div class="menu" v-if="pageConfig.id == 8">
        <div class="menu">
          <div class="item"><router-link to="/"> Flights </router-link></div>
          <div class="item"><router-link to="/hotelHome">Hotel</router-link></div>
          <div class="item"><router-link to="/activity">Activity</router-link></div>
          <div class="item" style="display: none">
            <a href="https://travel.aoflights.com/en/">Travel</a>
          </div>
          <!-- <div class="item">about</div> -->
        </div>
        <div @click="drawer = true" class="tnzfj" style="margin-left: 6px">
          <img src="@/assets/img/airpl.png" alt="" />
          <span style="font-size: 16px; margin-left: 6px" class="el-icon-arrow-up" v-if="drawer"></span>
          <span style="font-size: 16px; margin-left: 6px" class="el-icon-arrow-down" v-else></span>
        </div>
        <el-drawer class="sortDrawer-box" :visible.sync="drawer" :direction="direction">
          <div class="sortDrawer">
            <div class="sortDrawer-item" @click="tiaozhuan(1)">
              <img src="@/assets/img/topair.png" alt="" />Flights
            </div>
            <div class="sortDrawer-item" @click="tiaozhuan(2)">
              <img src="@/assets/img/tclvyou.png" alt="" />
              Travel
            </div>
            <div class="sortDrawer-item" v-if="loginShow" @click="tiaozhuan(3)">
              <img src="@/assets/img/tcchaxun.png" alt="" />
              Search Trips
            </div>
          </div>
        </el-drawer>
        <div class="zw">
          <!-- 占位置 -->
        </div>
      </div>
      <div class="menu" v-else>
        <div class="item"><router-link to="/">Home</router-link></div>
        <!-- <div class="item"><router-link to="/about">About Us</router-link></div> -->
        <div class="item">
          <router-link to="/Contact">Contact Us</router-link>
        </div>
        <!-- <div class="item">about</div> -->
      </div>

      <div class="dropDown">
        <div class="tips">24/7 Support</div>
        <div class="tphone">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link" style="display: flex; align-items: center">
              <template v-if="pageConfig.id == 8">
                <svg t="1721026961719" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5949" id="mx_n_1721026961720" width="20" height="20"
                  style="margin-right: 5px">
                  <path
                    d="M811.67 157.26H214.33C131.99 157.26 65 224.25 65 306.59v392c0 82.34 66.99 149.33 149.33 149.33h597.33c82.34 0 149.33-66.99 149.33-149.33v-392c0.01-82.34-66.98-149.33-149.32-149.33zM670.31 508.75c-0.12-0.12-0.25-0.23-0.38-0.35l216.4-188.83v379.02c0 7.09-1.01 13.94-2.87 20.44L670.31 508.75z m141.36-276.83c16.7 0 32.13 5.51 44.58 14.8L586.64 481.99c-41.97 36.59-105.29 36.62-147.28 0L169.75 246.73c12.45-9.3 27.89-14.81 44.59-14.81h597.33z m-669.14 487.1a74.524 74.524 0 0 1-2.87-20.43V319.57l216.4 188.83c-0.12 0.12-0.25 0.23-0.37 0.35L142.53 719.02z m71.8 54.24c-6.27 0-12.36-0.79-18.18-2.25l211.96-209.1c2.03-2 3.77-4.18 5.25-6.49 30.29 19.06 64.95 28.6 99.62 28.6 34.68 0 69.35-9.54 99.63-28.6a37.71 37.71 0 0 0 5.25 6.49l211.97 209.1a74.636 74.636 0 0 1-18.18 2.25H214.33z"
                    p-id="5950" fill="#0088b8"></path>
                </svg>
                {{ pageConfig.support_mail }}<i class="el-icon-arrow-down el-icon--right"></i>
              </template>
              <template v-else><i class="el-icon el-icon-phone"></i> {{ pageConfig.tel_from_overseas }}<i
                  class="el-icon-arrow-down el-icon--right"></i> </template>
            </span>
            <el-dropdown-menu slot="dropdown" class="my-dropdown-menu">
              <el-dropdown-item class="pwid">
                <div class="menuBox">
                  <div class="menuLeft">
                    <img src="@/assets/hotel/phone.svg" alt="" />
                  </div>
                  <div class="menuRight">
                    <div class="time">
                      {{ pageConfig.id == 8 ? "Australia 9am-5pm AEST" : "General enquiries" }}
                    </div>
                    <div class="phone">
                      {{ pageConfig.tel_general_enquiries }}
                    </div>
                  </div>
                </div>
                <div class="menuBox">
                  <div class="menuLeft">
                    <img src="@/assets/hotel/phone.svg" alt="" />
                  </div>
                  <div class="menuRight">
                    <div class="time">
                      {{ pageConfig.id == 8 ? "Overseas 7*24 Support" : "From overseas" }}
                    </div>
                    <div class="phone">
                      {{ pageConfig.tel_from_overseas }}
                    </div>
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="currencyType" @click="drawerMore = false" v-if="isHome">
          <el-dropdown trigger="click" @command="handleCommand" placement="bottom">
            <span class="el-dropdown-link">
              <img :src="bzTypeList[bzTypeIndex]?.icon" alt="" />
              <span>&nbsp;{{ option }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.value" v-for="(item, index) in bzTypeList" :key="index">
                <img :src="item.icon" alt="" />
                {{ item.value }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="isView" v-if="loginShow" @click="DrawerPage(3)">
          View My bookings
        </div>
        <div class="isLogin" @click="setLoginStatus(true)" v-if="loginShow">
          Login
        </div>
        <div class="more" @click="drawerMore = !drawerMore">
          <img src="@/assets/hotel/more.svg" alt="" />
        </div>

        <div class="isCard" v-if="!loginShow">
          <el-popover placement="bottom" v-model="loginPopover" width="250" trigger="click">
            <div class="Cardbox">
              <div class="userEmil" v-show="!loginShow">
                <h3>Hi</h3>
                <div class="emil">{{ user_info.email }}</div>
                <div class="aset">
                  <router-link to="/myinfo">Account Settings</router-link>
                </div>
              </div>
              <div class="Signup" @click="setLoginStatus(true)" v-if="loginShow">
                Signup / Login
              </div>
              <div class="itembox" v-if="!loginShow">
                <div class="rout">
                  <router-link to="/orderList?status=1"> My trips</router-link>
                </div>

                <div class="rout" v-if="!loginShow" @click="outLogin">
                  Logout
                </div>
              </div>
            </div>
            <svg slot="reference" t="1678263065586" class="icon" width="24" height="24" viewBox="0 0 32 32" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.591 19.4515C12.8501 20.4584 14.409 21.005 16.0141 21.0022C17.6192 20.9994 19.1762 20.4474 20.4319 19.4361C25.2483 21.9222 25.9203 26.4806 26.0612 27.9981C28.5899 25.3628 30.003 21.8338 30 18.1612C29.9997 14.4052 28.5245 10.8031 25.8988 8.14732C23.2731 5.49158 19.7121 3.99974 15.999 4C14.1605 4.00013 12.3401 4.36657 10.6416 5.0784C8.94304 5.79023 7.39976 6.83352 6.09983 8.14868C3.4745 10.8048 1.99975 14.4071 2 18.1631C2 21.9877 3.50585 25.4522 5.94071 28C6.08159 26.5403 6.79358 21.9473 11.591 19.4515ZM16 8.19531C19.0345 8.19531 21.5018 10.6911 21.5018 13.7589C21.5018 16.8266 19.0345 19.3205 16 19.3205C12.9674 19.3205 10.5001 16.8286 10.5001 13.7589C10.5001 10.6892 12.9674 8.19531 16 8.19531Z"
                fill="#0088B8" />
            </svg>
          </el-popover>
        </div>
      </div>
    </div>
    <el-drawer :with-header="false" :visible.sync="drawerMore" direction="ttb" custom-class="drawerMore"
      :size="drawerHeight" @open="handleDrawerOpen">
      <div class="moreCont" ref="contentRef">
        <div @click="DrawerPage(1)">Flights</div>
        <div @click="DrawerPage(2)">Hotel</div>
        <div @click="DrawerPage(4)">Activity</div>
        <div @click="DrawerPage(3)">View My bookings</div>
      </div>
    </el-drawer>
    <login v-if="loginStatus"></login>
    <register v-if="registerStatus"></register>
    <agreement v-if="agreementStatus"></agreement>
    <forgotPassword v-if="forgotPwdStatus"></forgotPassword>
    <resetPassword v-if="resetPwdStatus"></resetPassword>
    <editPassword v-if="editPwdStatus"></editPassword>
  </div>
</template>

<script>
import login from "../login/login.vue"
import register from "../register/register.vue"
import agreement from "../agreement/agreement.vue"
import forgotPassword from "../forgotPassword/forgotPassword.vue"
import resetPassword from "../resetPassword/resetPassword.vue"
import editPassword from "../editPassword/editPassword.vue"
import CNY from "@/assets/img/round-flag-CN.svg"
import USD from "@/assets/img/round-flag-US.svg"
import AUD from "@/assets/img/round-flag-AU.svg"
import EUR from "@/assets/img/round-flag-FR.svg"
import INR from "@/assets/img/inr.svg"
import { mapState } from "vuex"
import handleNotification from "./mixins/handleNotification"

export default {
  mixins: [handleNotification],
  components: {
    login,
    agreement,
    register,
    forgotPassword,
    resetPassword,
    editPassword,
  },
  data() {
    return {
      drawer: false,
      direction: "btt",
      drawerMore: false,
      bzTypeIndex: 0,
      istips: sessionStorage.getItem("istips") || true,
      option: "",
      // loginSatus: false,
      // loginShow: true,
      accountNumber: "",
      isHome: false,
      loginPopover: false,
      drawerHeight: '30%',
      contentRef: null,
      currencyIcon: {
        AUD,
        CNY,
        USD,
        EUR,
        INR,
      },
    }
  },
  watch: {
    $route: {
      handler(newV) {
        // console.log(newV);
        this.isHome = newV.name === "home" || newV.name === "activity" || newV.name === "hotelHome"
        // console.log(this.isHome);
      },
      immediate: true,
    },
    drawerMore(newVal) {
      if (newVal && this.$refs.contentRef) {
        this.resizeObserver?.observe(this.$refs.contentRef)
      } else {
        this.resizeObserver?.unobserve(this.$refs.contentRef)
      }
    },
    pageConfig: {
      handler(newValue) {
        if (Object.values(newValue).length > 0) {
          this.option = this.pageConfig.default_currency.split(",")[0]
          this.handleCommand(this.option)
          // console.log(this.option);
        }
      },
      immediate: true,
    },
    loginStatus: {
      handler(newVal) {
        if (newVal) {
          // console.log(newVal);
          document.title = "Sign in"
        } else {
          document.title = this.pageConfig.site_title
        }
      },
      immediate: true,
    },
  },

  computed: mapState({
    loginSatus: (state) => state.login.loginStatus,
    loginShow: (state) => state.login.loginShow,
    user_info: (state) => state.login.userInfo,
    loginStatus: (state) => state.login.loginStatus,
    registerStatus: (state) => state.register.registerStatus,
    agreementStatus: (state) => state.register.agreementStatus,
    forgotPwdStatus: (state) => state.register.forgotPwdStatus,
    editPwdStatus: (state) => state.register.editPwdStatus,
    resetPwdStatus: (state) => state.register.resetPwdStatus,
    pageConfig: (state) => state.common.pageConfig,
    bzTypeList: function (state) {
      return (
        state.common.pageConfig?.default_currency?.split(",").map((currency) => {
          // console.log(currency);
          return {
            icon: this.currencyIcon[currency],
            value: currency,
          }
        }) || []
      )
    },
  }),
  methods: {
    handleResize() {
      if (window.innerWidth > 768) {
        this.drawerMore = false
      }
    },
    handleDrawerOpen() {
      this.$nextTick(() => {
        this.calcContentHeight()
      })
    },
    calcContentHeight() {
      if (this.$refs.contentRef) {
        const contentHeight = this.$refs.contentRef.offsetHeight
        const maxHeight = window.innerHeight * 0.8
        this.drawerHeight = `${Math.min(contentHeight + 20, maxHeight)}px`
      }
    },
    DrawerPage(num) {
      if (num == 1) {
        this.$router.push("/")
        this.drawerMore = false
      }
      if (num == 2) {
        this.$router.push("/hotelHome")
        this.drawerMore = false
      }
      if (num == 3) {
        this.$router.push("/orderSearch")
        this.drawerMore = false
      }
      if (num == 4) {
        this.$router.push("/activity")
        this.drawerMore = false
      }
    },
    tiaozhuan(str) {
      // console.log(str);
      this.drawer = false
      this.drawerMore = false
      if (str == 1) {
        this.$router.push("/")
      }
      if (str == 2) {
        window.location.href = "https://travel.aoflights.com/"
      }
      if (str == 3) {
        this.$router.push("/orderSearch")
      }
    },
    editPassword() {
      this.$store.dispatch("register/set_editPwdStatus", true)
    },
    closexy() {
      this.istips = false
      sessionStorage.setItem("istips", false)
      this.setNotificationTop()
    },
    setLoginStatus(value) {
      this.drawerMore = false
      this.$store.dispatch("login/set_loginstatus", value)
    },
    getCloseDialog(value) {
      this.$store.dispatch("login/set_loginstatus", value)
    },
    outLogin() {
      this.handleCommand(this.option)
      this.loginPopover = false
      this.$store.dispatch("login/set_logout")
    },
    // 币种选择
    handleCommand(command) {
      this.drawerMore = false
      var storage = window.sessionStorage
      this.bzTypeIndex = this.bzTypeList.findIndex((item) => item.value === command)
      storage.setItem("Currency", command)
      this.$store.dispatch("common/set_Currency", command)
      this.option = command
    },
    // 卡片显隐
    isCard() { },
  },
  mounted() {
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.drawerMore) {
          this.calcContentHeight()
        }
      })
    }
    window.addEventListener('resize', this.handleResize)
    this.handleResize() // 初始化调用
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    window.removeEventListener('resize', this.handleResize)
  },
}

</script>

<style lang="scss" scoped>
@import "./nav.scss";
</style>

<style lang="scss">
.drawerMore {
  top: 1.3rem !important;
  // 移除固定高度
  // height: 25% !important;

  .moreCont {
    box-sizing: border-box;
    padding: 15px;
    overflow: visible;

    >div {
      padding: 12px 0;
      font-size: 16px;
    }
  }

  @media (max-height: 600px) {
    max-height: 90vh !important;
  }
}
</style>
